import * as React from "react";
import { playAudioForSuccess } from "../../../helpers/playAudioForSuccess";
import { query } from "./graph";
import { useApolloClient } from "@apollo/client";
import { useRouter } from "found";
import { useState } from "react";
import BarcodeReader from "react-barcode-reader";
import CenteredSpinner from "../../../components/CenteredSpinner";
import PendingStatusView from "../../../components/PendingStatusView";
import TabbedAppBar from "../../../components/TabbedAppBar";
import Typography from "@mui/material/Typography";
import withSnackbar from "../../../components/withSnackbar";

const ArtReadyApp = ({ showErrorSnackbar, showSuccessSnackbar }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { router } = useRouter();
  const apolloClient = useApolloClient();

  const handleBarcodeScan = barcode => {
    try {
      const barcodeData = JSON.parse(barcode);
      const { variant, type, id } = barcodeData;

      if (
        variant === "OBJECT" &&
        (type === "StockContainer" || type === "OrderProductionJob") &&
        id
      ) {
        setIsLoading(true);
        apolloClient
          .query({
            query,
            variables: { id },
            fetchPolicy: "network-only"
          })
          .then(
            ({
              data: {
                node,
                node: { __typename }
              }
            }) => {
              console.log(node);
              const orderProductionJob =
                __typename === "OrderProductionJob"
                  ? node
                  : node.orderProductionJob;
              const {
                order: { artworkStatus }
              } = orderProductionJob;

              console.log(`ARTWORK STATUS: ${artworkStatus}`);
              if (
                artworkStatus === "COMPLETE" ||
                artworkStatus === "REVIEWED" ||
                artworkStatus === "APPROVED"
              ) {
                showSuccessSnackbar("Artwork Ready");
                playAudioForSuccess();
              } else {
                showErrorSnackbar(`Artwork NOT Ready: ${artworkStatus}`);
              }
            }
          )
          .catch(e => {
            showErrorSnackbar(e.message);
          })
          .finally(() => setIsLoading(false));
      }
    } catch {
      setIsLoading(false);
      showErrorSnackbar("Error Scanning Barcode");
    }
  };

  return (
    <div>
      <TabbedAppBar
        title="Art Ready?"
        onRequestBack={() => router.push("/apps")}
      />
      {isLoading ? (
        <PendingStatusView status="Loading" />
      ) : (
        <div>
          <BarcodeReader
            onError={() => {
              showErrorSnackbar("Error scanning barcode");
              setIsLoading(false);
            }}
            onScan={handleBarcodeScan}
          />
          {false && <CenteredSpinner />}
          <Typography
            variant="h6"
            align="center"
            color="inherit"
            style={{ flexGrow: 1, marginTop: "10em" }}
          >
            Scan Carton to Check If Art is Ready
          </Typography>
        </div>
      )}
    </div>
  );
};

export default withSnackbar(ArtReadyApp);
